import { render, staticRenderFns } from "./DepartmentManagement.vue?vue&type=template&id=f59116ae&scoped=true"
import script from "./DepartmentManagement.vue?vue&type=script&lang=js"
export * from "./DepartmentManagement.vue?vue&type=script&lang=js"
import style0 from "./DepartmentManagement.vue?vue&type=style&index=0&id=f59116ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59116ae",
  null
  
)

export default component.exports